import { LatestVisitGetterNames } from './keys'
import { FlatAPIData, flattenJsonApiResponse } from '@/store/utils/converter'
import { PatientWithLatestVisitAttributes } from '@/jsonapi/PatientWithLatestVisit'
import { PatientWithLatestVisitState } from '@/store/modules/patient-with-latest-visit/types'

export type FlatPatientWithLatestVisit = FlatAPIData<PatientWithLatestVisitAttributes>

/* tslint:disable:no-shadowed-variable */
export const getters = {
  [LatestVisitGetterNames.patientWithLatestVisits]: (
    state: PatientWithLatestVisitState
  ): FlatPatientWithLatestVisit[] => {
    return state.patientWithLatestVisit.map(flattenJsonApiResponse)
  },
}
